/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  Forbidden,
  HeatPumpDeviceModel,
  NotFound,
  Unauthorized,
} from '../models';

export interface CrmInstallationsHeatPumpDeleteHeatPumpDeviceRequest {
    id: string;
    deviceId: string;
}

export interface CrmInstallationsHeatPumpGetHeatPumpDevicesRequest {
    id: string;
    useCache?: string;
}

/**
 * 
 */
export class CRMInstallationsHeatPumpApi extends runtime.BaseAPI {

    /**
     * Removes a heat pump device installation from the customer account. This action permanently deletes the device configuration and disconnects the heat pump from the system. Cannot be undone
     * Delete Heat Pump Installation
     */
    async crmInstallationsHeatPumpDeleteHeatPumpDeviceRaw(requestParameters: CrmInstallationsHeatPumpDeleteHeatPumpDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmInstallationsHeatPumpDeleteHeatPumpDevice.');
        }

        if (requestParameters.deviceId === null || requestParameters.deviceId === undefined) {
            throw new runtime.RequiredError('deviceId','Required parameter requestParameters.deviceId was null or undefined when calling crmInstallationsHeatPumpDeleteHeatPumpDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/heatpump/{deviceId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters.deviceId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a heat pump device installation from the customer account. This action permanently deletes the device configuration and disconnects the heat pump from the system. Cannot be undone
     * Delete Heat Pump Installation
     */
    async crmInstallationsHeatPumpDeleteHeatPumpDevice(requestParameters: CrmInstallationsHeatPumpDeleteHeatPumpDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.crmInstallationsHeatPumpDeleteHeatPumpDeviceRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves all heat pump device installations for a customer. Returns smart energy device details including configuration, connectivity status, and operational parameters. Supports optional cache control
     * Get All Heat Pump Installations
     */
    async crmInstallationsHeatPumpGetHeatPumpDevicesRaw(requestParameters: CrmInstallationsHeatPumpGetHeatPumpDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HeatPumpDeviceModel>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmInstallationsHeatPumpGetHeatPumpDevices.');
        }

        const queryParameters: any = {};

        if (requestParameters.useCache !== undefined) {
            queryParameters['useCache'] = requestParameters.useCache;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/heatpump`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all heat pump device installations for a customer. Returns smart energy device details including configuration, connectivity status, and operational parameters. Supports optional cache control
     * Get All Heat Pump Installations
     */
    async crmInstallationsHeatPumpGetHeatPumpDevices(requestParameters: CrmInstallationsHeatPumpGetHeatPumpDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HeatPumpDeviceModel>> {
        const response = await this.crmInstallationsHeatPumpGetHeatPumpDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
